module.exports = __webpack_public_path__ + "static/img/guiluyaoye4.472bad38.png";